import axios from "axios";
import appConfig from "./appConfig";
import authProvider from "./authProvider";

export const instance = axios.create({
    baseURL: (appConfig.BACKEND_API_URL || "").replace(/\/+$/, ""),
    timeout: 30000,
    headers: { 'Content-Type': 'application/json' },
    validateStatus: (status) => (status >= 200 && status < 300)
});


export const axiosAuthInterceptor = instance.interceptors.request.use(
    config =>
        authProvider.getAccessToken().then(token => {
            config.headers.Authorization = token ? `Bearer ${token}` : '';
            return config;
        }),
    error => Promise.reject(error)
);

export const parseAxiosError = (error) => {
    const parsed = {
        message: error?.response.data?.message ?? error?.response.data ?? error?.request.statusText ?? error.message ?? 'Unknow',
        status: error?.response.status ?? error.request.status ?? 0
    }
    const newError = new Error(`${parsed.status}: ${parsed.message}`);
    newError.status = parsed.status;
    return newError
};
